import React, { useMemo } from 'react';
import { useGetOutletsQuery } from '~/generated/hooks';
import { CacheContext } from './context';
import { Outlet } from '~/api';

export const CacheContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  // ===================== API
  const outletQueryResult = useGetOutletsQuery();
  const { data: outletsData, isLoading, refetch } = outletQueryResult;

  // ====================== COMPUTED
  /**
   * Utility function to get an outlet by ID
   */
  const getOutletById = useMemo(() => {
    return (id?: string): Outlet | undefined => {
      if (!id || !outletsData?.getOutlets?.items) return undefined;
      return outletsData.getOutlets.items.find(outlet => outlet.id === id);
    };
  }, [outletsData]);

  // ====================== VALUES
  const contextValue = useMemo(() => ({
    outlets: {
      data: outletsData,
      isLoading,
      refetch,
    },
    getOutletById,
  }), [outletsData, isLoading, refetch, getOutletById]);

  return (
    <CacheContext.Provider value={contextValue}>
      {children}
    </CacheContext.Provider>
  );
}; 